import { render, staticRenderFns } from "./IntegralExchange.vue?vue&type=template&id=7eb71a07&scoped=true&"
import script from "./IntegralExchange.vue?vue&type=script&lang=js&"
export * from "./IntegralExchange.vue?vue&type=script&lang=js&"
import style0 from "./IntegralExchange.vue?vue&type=style&index=0&id=7eb71a07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb71a07",
  null
  
)

component.options.__file = "IntegralExchange.vue"
export default component.exports